import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RestService } from '../../../../../service/rest.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../store/reducers';
import { CommonFinanceDocument } from '../../../../../models/finance-document.model';



@Component({
  selector: 'app-finance-member-adder',
  templateUrl: './finance-member-adder.component.html',
  styleUrls: ['./finance-member-adder.component.scss']
})
export class FinanceMemberAdderComponent implements OnInit {

  idFinanceDocument: string;
  parentMemberDocument: CommonFinanceDocument;
  // selected: CommonFinanceDocument;
  isAdd: boolean = false;

  constructor(public dialogRef: MatDialogRef<FinanceMemberAdderComponent>,
              protected restService: RestService,
              protected store: Store<fromRoot.AppState>,
              @Inject(MAT_DIALOG_DATA) public data: {id: string, parentMemberDocument: CommonFinanceDocument}) {
    this.idFinanceDocument = data.id;
    this.parentMemberDocument = data.parentMemberDocument;
    this.isAdd = data.id ? false : true;
  }

  ngOnInit() {
  }

  getFinanceDocument(data: CommonFinanceDocument) {
    this.dialogRef.close(data);
  }

  off() {
    this.dialogRef.close();
  }

}
